export default "__VITE_ASSET__9678787d__"